export default "__VITE_ASSET__B7sLZ4BO__"